export default __webpack_public_path__ + "static/media/loading.b51df3f3.gif";